import styles from "../styles.scss";
import {
  Layout,
  Loader,
  ProfileMenu,
  SideNavigation,
  UnAuthorizedErrorScreen,
} from "@/components";
import { Toaster } from "react-hot-toast";
import { useUserData } from "@/pages/application/hooks";
import { FC, ReactNode, useContext } from "react";
import { AuthContext } from "@/guards/auth/auth-context";
import { TOAST_DEFAULT_DURATION } from "@/constants";

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading, error } = useUserData(false, true);
  const { logout } = useContext(AuthContext);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.loader}>
          <Loader />
        </div>
      );
    }

    if (error) {
      return <UnAuthorizedErrorScreen onButtonClick={logout} />;
    }

    return (
      <>
        <div className={styles.mainLayoutHeader}>
          <div className={styles.headerMenu}>
            <ProfileMenu />
          </div>
        </div>

        <SideNavigation />

        {children}

        <Toaster
          position={"top-right"}
          gutter={10}
          containerStyle={{ top: 16 }}
          toastOptions={{ duration: TOAST_DEFAULT_DURATION }}
          reverseOrder
        />
      </>
    );
  };

  return <Layout>{renderContent()}</Layout>;
};
